'use client';
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FileDropzone;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const utils_1 = require("../utils");
function hasFiles(dataTransfer) {
    var _a;
    return Array.from((_a = dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.types) !== null && _a !== void 0 ? _a : []).includes('Files');
}
function FileDropzone({ onFilesSelected, title, description, accept, multiple = false, disabled = false, loading = false, className, icon, }) {
    const inputId = (0, react_1.useId)();
    const inputRef = (0, react_1.useRef)(null);
    const [isDragActive, setIsDragActive] = (0, react_1.useState)(false);
    const isUnavailable = disabled || loading;
    const emitFiles = (files) => {
        const normalizedFiles = Array.from(files !== null && files !== void 0 ? files : []);
        if (normalizedFiles.length === 0) {
            return;
        }
        onFilesSelected(multiple ? normalizedFiles : normalizedFiles.slice(0, 1));
    };
    const openFileDialog = () => {
        var _a;
        if (isUnavailable) {
            return;
        }
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const handleInputChange = (event) => {
        emitFiles(event.currentTarget.files);
        event.currentTarget.value = '';
    };
    const handleKeyDown = (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') {
            return;
        }
        event.preventDefault();
        openFileDialog();
    };
    const handleDragEnter = (event) => {
        if (isUnavailable || !hasFiles(event.dataTransfer)) {
            return;
        }
        event.preventDefault();
        setIsDragActive(true);
    };
    const handleDragOver = (event) => {
        if (isUnavailable || !hasFiles(event.dataTransfer)) {
            return;
        }
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
        setIsDragActive(true);
    };
    const handleDragLeave = (event) => {
        if (event.currentTarget.contains(event.relatedTarget)) {
            return;
        }
        setIsDragActive(false);
    };
    const handleDrop = (event) => {
        if (isUnavailable || !hasFiles(event.dataTransfer)) {
            return;
        }
        event.preventDefault();
        setIsDragActive(false);
        emitFiles(event.dataTransfer.files);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: className, children: [(0, jsx_runtime_1.jsx)("input", { accept: accept, className: 'sr-only', disabled: isUnavailable, id: inputId, multiple: multiple, onChange: handleInputChange, ref: inputRef, type: 'file' }), (0, jsx_runtime_1.jsxs)("div", { "aria-busy": loading || undefined, "aria-controls": inputId, "aria-disabled": isUnavailable, className: (0, utils_1.cn)('flex w-full flex-col items-center justify-center rounded-xl border border-dashed px-4 py-8 text-center outline-none transition-colors', 'focus-visible:shadow-[var(--aiq-ring-focus)]', isUnavailable
                    ? 'cursor-not-allowed border-neutral-100 bg-neutral-50'
                    : 'cursor-pointer border-neutral-200 bg-surface hover:border-primary-200 hover:bg-primary-50/40', isDragActive && !isUnavailable ? 'border-primary bg-primary-50/60 shadow-[var(--aiq-ring-focus)]' : ''), "data-drag-active": isDragActive ? 'true' : 'false', onClick: openFileDialog, onDragEnter: handleDragEnter, onDragLeave: handleDragLeave, onDragOver: handleDragOver, onDrop: handleDrop, onKeyDown: handleKeyDown, role: 'button', tabIndex: isUnavailable ? -1 : 0, children: [icon ? (0, jsx_runtime_1.jsx)("span", { className: 'mb-3 text-neutral-400', children: icon }) : null, (0, jsx_runtime_1.jsx)("span", { className: 'text-sm font-medium text-neutral-900', children: title }), description ? (0, jsx_runtime_1.jsx)("span", { className: 'mt-1 max-w-sm text-xs leading-5 text-neutral-500', children: description }) : null] })] }));
}
